export type SubscriptionStatus = "Aktif" | "Uyarıda" | "Pasif";
export type PaymentStatus = "Yapıldı" | "Beklemede";

export interface Subscription {
  id: string;
  panelUsageStatus: SubscriptionStatus;
  monthlyPaymentStatus: PaymentStatus;
  servicePeriod: string;
  lastCheckDate: string;
  usageExpiryDate: string;
  supportContact: string;
  adminNote: string;
  paymentReminder: boolean;
  salonName: string;
  contactPerson: string;
  contactPhone: string;
  contactEmail: string;
}

export const subscription: Subscription = {
  id: "sub-001",
  panelUsageStatus: "Aktif",
  monthlyPaymentStatus: "Yapıldı",
  servicePeriod: "Mayıs 2026",
  lastCheckDate: "2026-05-08",
  usageExpiryDate: "2026-06-01",
  supportContact: "+90 212 555 6677",
  adminNote: "Tüm modüller aktif. Güncelleme bildirimi 15 Mayıs'ta gönderilecek.",
  paymentReminder: false,
  salonName: "Kuğu Spa Wellness",
  contactPerson: "Ali Yıldırım",
  contactPhone: "+90 538 777 8899",
  contactEmail: "ali.yildirim@kuguspa.com",
};